/* ══════════════════════════════════════════════════════════════════
   购物车页面运行时。

   它做的事只有一件：把「点一下 + 号 → 整页刷新」换成局部替换。
   页面本身没有它也是完整的 —— 数量和删除是真链接
   （/cart/change?line=N&quantity=M），备注是真表单。

   两个和抽屉的分工：
     · 钩子叫 data-cp-*，不叫 data-qty。抽屉的监听挂在 document 上，
       同名钩子会让一次点击被两边各处理一遍，数量直接跳两格。
     · 一次请求同时要回**两个** section 的 HTML（本页 + 抽屉），
       所以改完数量，表头的角标和抽屉里的内容也是新的。
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;

  function page() { return document.querySelector('[data-cart-page]'); }

  function sectionIds() {
    var el = page();
    var ids = el && el.dataset.section ? [el.dataset.section] : [];
    if (document.querySelector('[data-cart-drawer]')) ids.push('cart-drawer');
    return ids;
  }

  function swap(sections) {
    if (!sections) return;
    var el = page();
    var ids = sectionIds();

    if (el && sections[ids[0]]) {
      var next = new DOMParser().parseFromString(sections[ids[0]], 'text/html')
        .querySelector('[data-cart-page]');
      if (next) el.innerHTML = next.innerHTML;
    }
    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer && sections['cart-drawer']) {
      var nextDrawer = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html')
        .querySelector('[data-cart-drawer]');
      /* 抽屉是关着的，只换内容不碰它的开合状态 */
      if (nextDrawer) drawer.innerHTML = nextDrawer.innerHTML;
    }
  }

  function updateCount(n) {
    document.querySelectorAll('[data-eb-cart-count]').forEach(function (b) {
      b.textContent = n;
      b.hidden = n === 0;
    });
  }

  function change(key, quantity) {
    if (busy) return;
    busy = true;
    var el = page();
    if (el) el.classList.add('is-busy');

    /* 跟车买的延保（嵌套行）数量跟车走，和抽屉同一个规矩 */
    var kids = el ? el.querySelectorAll('[data-parent-key="' + key + '"]') : [];
    var url = 'cart/change.js';
    var payload = { id: key, quantity: quantity, sections: sectionIds().join(',') };
    if (kids.length) {
      var updates = {};
      updates[key] = quantity;
      kids.forEach(function (k) { updates[k.dataset.lineKey] = quantity; });
      url = 'cart/update.js';
      payload = { updates: updates, sections: sectionIds().join(',') };
    }

    fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        swap(data.sections);
        if (typeof data.item_count === 'number') updateCount(data.item_count);
        if (window.EB && EB.emit) EB.emit('cart:changed', { count: data.item_count });
      })
      /* 网络出问题就退回整页跳转 —— 那条链接本来就是对的 */
      .catch(function () { window.location.href = root + 'cart'; })
      .finally(function () {
        busy = false;
        var now = page();
        if (now) now.classList.remove('is-busy');
      });
  }

  document.addEventListener('click', function (e) {
    var hit = e.target.closest('[data-cp-qty]');
    if (!hit || !hit.closest('[data-cart-page]')) return;
    if (hit.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }

    var line = hit.closest('[data-cp-line]');
    if (!line || !line.dataset.lineKey) return;

    e.preventDefault();
    change(line.dataset.lineKey, parseInt(hit.dataset.cpQty, 10));
  });

  /* 订单备注：停手 600ms 再提交，不是每敲一个字发一次 */
  document.addEventListener('input', function (e) {
    var note = e.target.closest('[data-cp-note]');
    if (!note || note.dataset.bound === '1') return;
    note.dataset.bound = '1';

    var save = function () {
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
    };
    note.addEventListener('input', window.EB && EB.debounce ? EB.debounce(save, 600) : save);
  });
})();
